@if (isUserLoggedIn) {
  <label class="searchbox" [class.dirty]="!!searchInput.value">
    <input
      #searchInput
      [ngModel]="searchValue"
      [placeholder]="'homescreen.placeholder' | cxTranslate"
      autocomplete="off"
      aria-describedby="initialDescription"
      aria-controls="results"
      aria-autocomplete="both"
      (click)="open()"
      (focus)="open()"
      (input)="search(searchInput.value)"
      (keydown.escape)="onBlur()"
      (keydown.enter)="
        close($event, true);
        launchSearchResult($event, searchInput.value);
        updateChosenWord(searchInput.value)
      "
      value="{{ chosenWord }}" />
    <button
      role="presentation"
      class="search-icon"
      [disabled]="searchInput.value.length === 0">
      <cx-icon
        [type]="iconTypes.SEARCH"
      (click)="launchSearchResult($event, searchInput.value)"></cx-icon>
    </button>
  </label>
  @if (
    closeDropDown && !hideSearchHistory && !quickOrder && results$
    | async; as result
    ) {
    <div
      class="results"
      id="results"
      role="listbox">
      @if (result.products) {
        <ul class="products" tabindex="0">
          <li class="drop-down-header">
            <span class="drop-down-title">
              {{ 'searchProduct.matchingProducts' | cxTranslate }}
            </span>
            <a
              class="push-right all-results-link"
              (click)="launchSearchResult($event, searchInput.value)">
              {{ 'searchProduct.seeAll' | cxTranslate }}
            </a>
          </li>
          @for (product of result.products; track product) {
            <li>
              <a
                [class.has-media]="config.displayProductImages"
                [routerLink]="['/product', product.code, product.code]"
                (blur)="close($event)"
                (click)="close($event, true)">
                @if (config.displayProductImages && product?.images) {
                  <cx-media
                    [container]="product?.images?.PRIMARY"
                    format="thumbnail "
                    role="presentation "
                  class=""></cx-media>
                }
                @if (config.displayProductImages && product?.images === undefined) {
                  <img
                    [src]="fallbackImage"
                    format="thumbnail "
                    role="presentation "
                    class="thumbnail-img"
                    alt="defImg" />
                }
                <div class="name" [innerHTML]="product.nameHtml"></div>
              </a>
            </li>
          }
        </ul>
      }
    </div>
  }
  @if (
    closeDropDown && hideSearchHistory && !quickOrder && value$
    | async; as item
    ) {
    <div
      role="listbox"
      class="searchHistory"
      id="searchHistory">
      @if (item.recentSearchText) {
        <ul
          class="products resetListStyle"
          tabindex="0"
          >
          <li class="drop-down-header">
            <span class="drop-down-title history-font-size">
              {{ 'searchProduct.recentSearches' | cxTranslate }}
            </span>
          </li>
          @for (item of item.recentSearchText; track item) {
            <li
              class="itemHistory"
              (click)="goToSearch(item)">
              <a (blur)="close($event)" (click)="close($event, true)">{{ item }}</a>
            </li>
          }
        </ul>
      }
    </div>
  }
  @if (quickOrder && showQuickOrder && results$ | async; as result) {
    <div
      class="results"
      id="quickOrder"
      role="listbox"
      (blur)="onBlur()">
      @if (result?.products?.length === 0 && result?.message != null) {
        <ul
          class="products"
          tabindex="0">
          <li>
            <a class="resultnot-found">
              {{ 'searchProduct.noResultsFound' | cxTranslate }}
            </a>
          </li>
        </ul>
      }
      @if (result.products) {
        <ul class="products" tabindex="0">
          @for (product of result.products; track product) {
            <li>
              <a>
                <div
                  class="name"
                  [innerHTML]="product.nameHtml"
                (click)="quickOrderClick(product)"></div>
              </a>
            </li>
          }
        </ul>
      }
    </div>
  }
}
